export class Solicitacoes {
  id: number;
  idMembroSolicitante: number;
  descricaoSolicitante: string;
  idMembroAprovador: number;
  descricaoAprovador: string;
  idTipoAprovacao: number;
  idStatus: number;
  dataInicio: Date;
  dataFim: Date;
  dataAprovacao?: Date;
  dataRejeicao?: Date;
  ativo: boolean;
  aceiteTermo: boolean;
}

export enum SolicitacoesStatus {
  EmAnalise = 1,
  Aprovado = 2,
  Rejeitado = 3,
}
